import React from 'react';

import { LiliButton } from '@lili/lili-frontend-common';

interface IProps {
  title: string;
  className?: string;
}

const LoginButton = ({ title, className }: IProps) => (
  <LiliButton id='LoginButton' title={title} className={`${className} text-sm w-full h-12`} />
);

export default LoginButton;
